import React from "react";
import atoms from "../../../atoms";
import moment from "moment";
import {
    convertToCommaFormat,
    currencySymbol,
    priceTagFormatter,
} from "../../../../constants/utils";
import constant from "../../../../constants/constant";

import ThreeDots from "../../../../assets/Images/threeDots.svg";

import { RiDeleteBin6Line } from "react-icons/ri";
import { AiOutlineEye } from "react-icons/ai";
import { EInProcessData, EInProcessProps } from "./interface";
import { RxUpdate } from "react-icons/rx";
import { useNavigate } from "react-router";
import { FaPrint } from "react-icons/fa6";
import { FiShare } from "react-icons/fi";
import { PiPlaceholderFill } from "react-icons/pi";
import { MdOutlineDownloadDone, MdOutlineFileDownload } from "react-icons/md";
const { Search, Table, Button, Pagination, Image } = atoms;

const Index = ({
    receiptData,
    setSearch,
    setLimitPerPage,
    setCurrentPage,
    currentPage,
    limit,
    handleReadyOrder,
    handlePrintSharePdf,
    handleOnHoldOrder,
    storeDataInSession,
    handleSharePdf,
    handleSorting,
    handleDownload,
    handleOrderFromPdf
}: EInProcessProps) => {
    const navigate = useNavigate();

    const columns = [
        {
            name: "Date",
            selector: (row: EInProcessData) =>
                moment(row?.createdAt).format("DD/MM/YYYY"),
            width: "100px",
            sortField: "createdAt",
            sortable: true,
        },
        {
            name: "Online  Order No.",
            selector: (row: EInProcessData) => row?.order_id_display,
            width: "150px",
        },
        {
            name: "Customer Name",
            selector: (row: EInProcessData) => row?.customer?.name || "-",
            width: "150px",
        },
        {
            name: "Mobile No.",
            selector: (row: EInProcessData) => row?.customer?.mobile,
            width: "150px",
        },
        {
            name: "Total Amount",
            selector: (row: EInProcessData) =>
                priceTagFormatter(row?.total_amount) || "-",
            width: "150px",
        },
        {
            name: `Total Amount (${currencySymbol()})`,
            selector: (row: EInProcessData) => (
                <>
                    <div>
                        <p className="mb-1 ">
                            Items Value :{" "}
                            {priceTagFormatter(row?.total_amount)}
                        </p>
                        <p className="mb-1 ">
                            Advance Paid :{" "}
                            {priceTagFormatter(row?.total_paid_amount)}
                        </p>
                        <p className="mb-1 ">
                            Pending Amount :{" "}
                            {priceTagFormatter(Number(row?.total_amount) - Number(row?.total_paid_amount))}
                        </p>
                    </div>
                </>
            ),
            width: "200px",
        },
        {
            name: "Total Items",
            selector: (row: EInProcessData) => (
                <>
                    <div>
                        <p className="mb-1 ">Total Items : {row.total_order_items}</p>
                        <p className="mb-1 ">
                            Delivered : {row.total_delivered_order_items}
                        </p>
                        <p className="mb-1 ">Pending : {row.total_pending_order_items}</p>
                    </div>
                </>
            ),
            width: "140px",
        },
        {
            name: "Delivery Date",
            selector: (row: EInProcessData) =>
                moment(row?.delivery_date).isValid()
                    ? moment(row?.delivery_date).format("DD/MM/YYYY")
                    : "-",
            width: "150px",
            sortField: "delivery_date",
            sortable: true,
        },
        {
            name: "Delivery",
            selector: (row: any) => row?.order_status || "-",
            width: "150px",
            text: "center",
        },
        { name: "Action", selector: (row: any) => row?.action, center: true },
    ];

    return (
        <>
            <div className="mt-md-0 mt-3">
                <div className="row">
                    <div className="col-md-6">
                        <Search
                            className="search search-style w-100"
                            searchCallBack={(e: string) => {
                                setSearch(e);
                            }}
                        />
                    </div>
                    <div className='col-md-6 mt-md-0 mt-3 d-flex justify-content-end'>
                        <Button onClick={() => handleDownload()}>Download</Button>
                    </div>
                </div>

                <div>
                    <Table
                        columns={columns}
                        data={receiptData?.data?.map((item: any) => {
                            return {
                                ...item,
                                order_status: item?.store_pick_up ? (
                                    <div className="background-light-yellow border-product-radius custom-badge">
                                        <p className="color-yellow m-1 p-1">{"Store pickup"}</p>
                                    </div>
                                ) : (
                                    <div className="background-light-green border-product-radius custom-badge">
                                        <p className="color-green m-1 p-1">{"Home pickup"}</p>
                                    </div>
                                ),
                                action: (
                                    <>
                                        {
                                            <div className="table-data-width">
                                                <button
                                                    className="btn dropdown-dots shadow-none action-button"
                                                    type="button"
                                                    id="dropdownMenuButton1"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <Image src={ThreeDots} />
                                                </button>
                                                <ul
                                                    className="dropdown-menu dropdown-menu-end dropdown-style zindex-tooltip"
                                                    aria-labelledby="dropdownMenuButton1"
                                                    style={{ width: "210px" }}
                                                >
                                                    {/* Update Option */}
                                                    <li>
                                                        <button
                                                            className="dropdown-item dropdown-item-size"
                                                            onClick={() => {
                                                                storeDataInSession({
                                                                    name: item?.customer?.name || "",
                                                                    mobile: item?.customer?.mobile || NaN,
                                                                    totalPayable: item?.total_amount || 0,
                                                                });
                                                                navigate(`/online/sales-cart/${item?.id}`);
                                                            }}
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <RxUpdate />
                                                                <span className="ms-2 mb-0">Update</span>
                                                            </div>
                                                        </button>
                                                    </li>
                                                    <hr className="my-1"></hr>
                                                    {/* Order form Pdf Section */}
                                                     <li>
                                                        <button className="dropdown-item dropdown-item-size"
                                                            onClick={() => handleOrderFromPdf(item?.id)}>
                                                            <div className='d-flex align-items-center'>
                                                                <MdOutlineFileDownload />
                                                                <span className='ms-2 mb-0'>Order Form Pdf</span>
                                                            </div>
                                                        </button>
                                                    </li>
                                                    <hr className="my-1"></hr> 
                                                    {/* Download Option */}

                                                    <li>
                                                        <button
                                                            className="dropdown-item dropdown-item-size"
                                                            onClick={() => handlePrintSharePdf(item?.id)}
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <MdOutlineFileDownload />
                                                                <span className="ms-2 mb-0">Adv Receipt Pdf</span>
                                                            </div>
                                                        </button>
                                                    </li>
                                                    <hr className="my-1"></hr>

                                                    {/* Share Option */}
                                                    <li>
                                                        <button
                                                            className="dropdown-item dropdown-item-size"
                                                            onClick={() => handleSharePdf(item?.id, true)}
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <FiShare />
                                                                <span className="ms-2 mb-0">Share Adv Rec</span>
                                                            </div>
                                                        </button>
                                                    </li>
                                                    {item.order_status !==
                                                        constant.ORDER_STATUS.ON_HOLD && (
                                                            <>
                                                                <hr className="my-1"></hr>
                                                                <li>
                                                                    <button
                                                                        className="dropdown-item dropdown-item-size"
                                                                        onClick={() => handleOnHoldOrder(item?.id)}
                                                                    >
                                                                        <div className="d-flex align-items-center">
                                                                            <PiPlaceholderFill />
                                                                            <span className="ms-2 mb-0">
                                                                                {" "}
                                                                                Hold Order Ready
                                                                            </span>
                                                                        </div>
                                                                    </button>
                                                                </li>
                                                            </>
                                                        )}
                                                    {item.order_status !==
                                                        constant.ORDER_STATUS.READY && (
                                                            <>
                                                                <hr className="my-1"></hr>
                                                                <li>
                                                                    <button
                                                                        className="dropdown-item dropdown-item-size"
                                                                        onClick={() => handleReadyOrder(item?.id)}
                                                                    >
                                                                        <div className="d-flex align-items-center">
                                                                            <MdOutlineDownloadDone size={"1.2em"} />
                                                                            <span className="ms-2 mb-0">
                                                                                Order Ready
                                                                            </span>
                                                                        </div>
                                                                    </button>
                                                                </li>
                                                            </>
                                                        )}
                                                </ul>
                                            </div>
                                        }
                                    </>
                                ),
                            };
                        })}
                        handleSorting={handleSorting}
                    />
                </div>
                <div>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={receiptData?.totalPages}
                        onChangePage={(page: number) => setCurrentPage(page)}
                        setLimit={(e: number) => setLimitPerPage(e)}
                        limit={limit}
                    />
                </div>
            </div>
        </>
    );
};

export default Index;
